import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClassCardComponent } from './class-card/class-card.component';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { ContinueToPayComponent } from './continue-to-pay/continue-to-pay.component';
import { PipeModule } from 'src/app/pipes/pipe-module.module';
import { UnavailableTestComponent } from './unavailable-test/unavailable-test.component';
import { GeneralesComponentsModule } from 'src/app/generales-components/generales-components.module';

const declarations = [
  ClassCardComponent,
  ContinueToPayComponent,
  UnavailableTestComponent,
];

@NgModule({
  declarations,
  imports: [
    IonicModule,
    CommonModule,
    RouterModule,
    PipeModule,
    GeneralesComponentsModule,
  ],
  exports: declarations,
})
export class ModuleShowComponentsModule {}
